/*
  Analytics event wiring for interactions that happen client-side after page load
  (add_to_cart, remove_from_cart) rather than on a full page render. Sprint 24
  (Analytics & Tracking).

  Runs only if `subscribe`/`PUB_SUB_EVENTS` are already defined (pubsub.js/constants.js,
  both loaded globally before this file in layout/theme.liquid) and only sends data if
  `gtag`/`fbq` are already defined (i.e. a real GA4/Meta Pixel ID was configured in the
  Theme Editor - see snippets/toylivo-analytics.liquid). If neither is configured, every
  function below still runs but its `typeof` guards make it a no-op - nothing is sent
  anywhere.

  add_to_cart: hooks the existing PUB_SUB_EVENTS.cartUpdate event already published by
  assets/product-form.js (standard "Add to cart" button) and assets/quick-add-bulk.js
  (collection-page quick add), filtered to only those two real "an item was just added"
  sources - never fires from a quantity-change or removal, by construction, so no before/
  after cart-state diffing is needed.

  remove_from_cart: hooks a click on the existing <cart-remove-button> custom element
  (assets/cart.js) directly, at the moment of the click - also unambiguous by
  construction (this button's only job is removing a line). Reads product name/price
  from the line item's own already-rendered DOM (data attributes and text content
  already present for the customer to see), not from a second network request.
*/
(function () {
  function trackAddToCart(source, productVariantId, cartData) {
    if (source !== 'product-form' && source !== 'quick-add' && source !== 'quick-add-bulk') return;
    if (!cartData || typeof cartData !== 'object') return;

    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    var price = typeof cartData.price === 'number' ? cartData.price / 100 : undefined;
    var item = {
      item_id: cartData.sku || cartData.variant_id || productVariantId,
      item_name: cartData.product_title || cartData.title,
      item_brand: cartData.vendor,
      item_category: cartData.product_type,
      price: price,
      quantity: cartData.quantity || 1,
    };

    if (typeof gtag === 'function') {
      gtag('event', 'add_to_cart', {
        currency: currency,
        value: price ? price * item.quantity : undefined,
        items: [item],
      });
    }
    if (typeof fbq === 'function') {
      fbq('track', 'AddToCart', {
        content_ids: [item.item_id],
        content_type: 'product',
        content_name: item.item_name,
        value: price,
        currency: currency,
      });
    }
  }

  function trackRemoveFromCart(button) {
    var row = button.closest('.cart-item') || button.closest('[data-quantity-line-key]');
    if (!row) return;

    var titleEl = row.querySelector('.cart-item__name, .cart-item__details a');
    var priceEl = row.querySelector('.cart-item__price-wrapper .price, .price');
    var itemName = titleEl ? titleEl.textContent.trim() : undefined;
    var quantityInput = row.querySelector('.quantity__input');
    var variantId = quantityInput ? quantityInput.dataset.quantityVariantId : undefined;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';

    var item = {
      item_id: variantId,
      item_name: itemName,
    };

    if (typeof gtag === 'function') {
      gtag('event', 'remove_from_cart', {
        currency: currency,
        items: [item],
      });
    }
    if (typeof fbq === 'function' && itemName) {
      fbq('track', 'RemoveFromCart', {
        content_type: 'product',
        content_name: itemName,
      });
    }
    void priceEl;
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      trackAddToCart(event.source, event.productVariantId, event.cartData);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('cart-remove-button');
    if (button) trackRemoveFromCart(button);
  });
})();
